import { defineComponent, PropType } from "vue";
import { Link } from "@/interfaces/Link";
export default defineComponent({
  props: {
    items: { type: Array as PropType<Link[]>, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
  },
});
